<template>
  <component
    :is="tag"
    :to="to"
    :href="href"
    :target="href ? '_blank' : undefined"
    :type="tag === 'button' ? 'button' : undefined"
    class="flex h-[44px] w-full items-center pr-4 pl-5 active:bg-gray-100"
    @click="emit('click')"
  >
    <component :is="icon" class="size-6 shrink-0 text-gray-800" />
    <span class="ml-4 text-[16px] leading-[18px] text-gray-800">
      <slot />
    </span>
  </component>
</template>

<script setup lang="ts">
import { computed, type Component } from 'vue'
import { RouterLink } from 'vue-router'

const props = defineProps<{
  icon: Component
  to?: string
  href?: string
}>()

const emit = defineEmits<{ click: [] }>()

const tag = computed(() => {
  if (props.to) return RouterLink
  if (props.href) return 'a'
  return 'button'
})
</script>
